/**
 * Returns a boolean indicating whether the code is running on the server side or not,
 * determined by the presence of the `window` object.
 * @returns {boolean} True if the code is running on the server side, false otherwise.
 */
export function runningOnServer() {
  return typeof window === 'undefined'
}
